import { Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { StoreProduct } from '@nucleus-commerce/api-client/admin';
import { useFormat } from '@nucleus-commerce/i18n/react';
import { Badge } from '@nucleus-commerce/ui/components/badge';

import { nextScheduledChange } from '../api/mappers';

/** "Scheduled" with the next pending status change on hover and for assistive tech. */
export function ScheduledBadge({ row }: { row: Pick<StoreProduct, 'publishAt' | 'unpublishAt'> }) {
  const { t } = useTranslation('storeCatalog');
  const format = useFormat();
  const next = nextScheduledChange(row);
  if (!next) return null;
  const when = format.dateTime(next.at);
  const text = t(`scheduled.${next.kind}`, { when });
  return (
    <Badge
      variant="outline"
      className="gap-1 font-normal"
      title={`${text} · ${format.utc(next.at)}`}
    >
      <Clock className="size-3" aria-hidden />
      {t('scheduled.badge')}
      <span className="sr-only">: {text}</span>
    </Badge>
  );
}
